import React from 'react'
import { Grid } from '@mui/material'

import PageWrapper from 'Pages/@PageWrapper'
import { TourProvider, TourTarget } from "@tour"
import { CUSTOM_DASHBOARD_ROUTES } from '@constants/routes'
import {isSystemBusy} from "@signals";
import {dipFutureRangeDates} from "../../../@components/DynamicCommonFilters/@components/Dates/DateRange/Ranges";
import EmbargoDateFilters from "./Filters";
import EmbargoDateTable from "./Table"
import {isEmptyEmbargoDate} from "./@signals";
import EmbargoReportFormDrawer from "./ReportForm";



export default function EmbargoDatePage() {

	const props = {
		head: CUSTOM_DASHBOARD_ROUTES.EMBARGO_TITLE,
		title: CUSTOM_DASHBOARD_ROUTES.EMBARGO_TITLE,
		subtitle: CUSTOM_DASHBOARD_ROUTES.EMBARGO_SUBTITLE,
		isEmpty: isEmptyEmbargoDate.value,
		hasErrors: isSystemBusy.value,
		actionProps: {
			dateRangeProps: { ranges: dipFutureRangeDates, shouldDisableDate: () => {} }
		},
		tourPageKey: "embargo"
	}

	return <PageWrapper {...props} filters={<EmbargoDateFilters/>}>
		<Grid container spacing={2}>
			<Grid item xs={12} sx={{ position: "relative" }}>
				<TourTarget name="embargo-table" height={350} />
				<EmbargoDateTable />
			</Grid>
			<Grid item xs={12}>
				<EmbargoReportFormDrawer />
			</Grid>
		</Grid>
	</PageWrapper>
}